<template>
    <div class="has-text-centered" v-html="embed"></div>
</template>

<script>
export default {
    props: {
        embed: {
            type: String,
            default: undefined,
        },
    },
};
</script>

<style></style>
